import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { fetchReactiveResponseSettings,
  editReactiveResponseSettings,
  editReactiveResponsePriority } from "../actions/index";
import ReactiveResponsesForm from "./ReactiveResponsesForm";
import { CSSTransitionGroup } from 'react-transition-group';
import { toastr } from "react-redux-toastr";
import { Link } from "react-router-dom";

class ReactiveResponsesEdit extends Component {
  static propTypes = {
    fetchReactiveResponseSettings: PropTypes.func.isRequired,
    editReactiveResponseSettings: PropTypes.func.isRequired,
    editReactiveResponsePriority: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    settings: PropTypes.object.isRequired
  };

  componentDidMount() {
    this.props.fetchReactiveResponseSettings();
  }

  onSubmit(state) {
    this.props
      .editReactiveResponseSettings(state)
      .then(response => {
        if (response.payload !== undefined) {
          toastr.success("Settings saved!");
        }
      });
  }

  onPrioritySubmit(state) {
    this.props
      .editReactiveResponsePriority(state)
      .then(response => {
        if (response.payload !== undefined) {
          toastr.success("Settings saved!");
        }
      });
  }

  render() {
    if (this.props.settings == undefined) {
      return (
        <CSSTransitionGroup
          transitionName="spinner"
          transitionAppear={true}
          transitionAppearTimeout={500}
        >
          <div id="content" className="spinner-content">
            <div className="vertical-center">
              <i className="fa fa-refresh fa-4x fa-spin" />
            </div>
          </div>
        </CSSTransitionGroup>
      );
    }
    return (
      <div>
        <h1>Reactive Responses</h1>
        <p>When a lead takes certain actions, these text messages will be sent out to encourage engagement. Only one message will be sent per day. Individual reactive responses will be sent once every 14 days. You may toggle these messages on or off as desired. *</p>
        <p>
          If office hours are enabled, text messages will only be sent during the set office hours. If not enabled, they will be sent at any time.&nbsp;
          <Link to={`/settings`}>
            Edit Office Hours →
          </Link>
        </p>
        <ReactiveResponsesForm
          handleSubmit={this.onSubmit.bind(this)}
          handlePrioritySubmit={this.onPrioritySubmit.bind(this)}
          settings={this.props.settings}
        />
        <p className="m-t-10">
          * Reactive Responses toggled on will be sent to any lead that exhibits the specific behavior, unless that lead has been opted out of receiving ALL Reactive Responses.
        </p>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { settings: state.reactiveResponseSettings.all.reactive_response_settings };
}

export default connect(
  mapStateToProps,
  {  fetchReactiveResponseSettings, editReactiveResponseSettings, editReactiveResponsePriority }
)(ReactiveResponsesEdit);
